// Read lazily: a build without the mobietrain env vars must still boot, and only fails once a
// mobietrain-backed feature (Academy content or media) is actually used.
export const getMobietrainApiUrl = (): string => {
  const base = import.meta.env.VITE_MOBIETRAIN_API_URL;
  if (!base) {
    throw new Error('VITE_MOBIETRAIN_API_URL is not set');
  }
  // Every mobietrain-api route lives under /api: the deployed ingress only routes /api/*
  // to mobietrain-api (and strips the prefix). Prefix all mobietrain URLs with this so the
  // /api segment is never forgotten.
  return `${base.replace(/\/+$/, '')}/api`;
};
